export default __webpack_public_path__ + "static/media/771.0c9929d7.png";